export var createAbstractOperator = function createAbstractOperator(_ref) {
  var propertyValue = _ref.propertyValue,
      operator = _ref.operator;

  if (propertyValue === null) {
    if (operator === 'eq') return 'is_null';
    if (operator === 'ne') return 'is_not_null';
  }

  return operator;
};